import { Mongo } from './mongo';
export namespace User {
  export interface User {
    _id: string;
    roles: UserRole[];
    profile: UserProfile;
    tenants: string[];
    authToken?: string;
    authenticated?: boolean;
    enabled: boolean;
    consents?: Consents;
  }

  export interface Consents {
    "directMarketing": boolean;
    "serviceAndContractFulfillment": boolean;
    "strategicPlanningAndAnalytics": boolean;
    "termsAndConditions": boolean;
    "timestamp": Mongo.Date
    "unfairTermsAndConditions": boolean;
  }

  export interface UserProfile {
    name: string;
    surname: string;
    phone?: string;
    dateOfBirth?: Mongo.Date;
    additionalFields?: UserProfile.AdditionalField[];
  }

  export namespace UserProfile {
    export interface AdditionalField {
      field: string;
      value: string;
    }
  }

  export enum UserRole {
    NATIVA = 'nativa',
    MANAGER = 'manager',
    USER = 'user',
    LOCKED_USER = 'locked-user',
    ADMIN = 'admin'
  }
}
